<template>
  <canvas
    ref="siloCanvas"
    style="position: absolute; width: 100%; height: 100%"
  ></canvas>
</template>

<script>
import { mapGetters } from "vuex";

import emptySiloWithoutShadeImageSrc from "@/plugins/silo_canvas/assets/empty_silo_without_shade.png";
import emptySiloWithShadeImageSrc from "@/plugins/silo_canvas/assets/empty_silo_with_shade.png";
import siloLiquidImageSrc from "@/plugins/silo_canvas/assets/silo_liquid.png";

export default {
  name: "koiote-silo-canvas",

  props: {
    input: Object,
  },

  data() {
    return {
      emptySiloWithShadeImage: null,
      emptySiloWithoutShadeImage: null,
      siloLiquidImage: null,
    };
  },

  computed: {
    allImagesLoaded() {
      return this.emptySiloWithShadeImage != null && this.emptySiloWithoutShadeImage != null && this.siloLiquidImage;
    },

    value() {
      return (
        this.actualPage()
          .global_item_list.find((gi) => gi.settings.component_type.includes("connection"))
          .customized.vartable.find((v) => v.formatted_address == this.input.customized.address)?.value || 0
      );
    },
  },

  methods: {
    ...mapGetters(["actualPage"]),

    async applyMask() {
      const canvas = this.$refs.siloCanvas;
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      if (this.emptySiloWithoutShadeImage && this.siloLiquidImage && this.emptySiloWithShadeImage && canvas) {
        const newHeight = (this.value * canvas.height) / (this.input?.customized?.maximum_value || 100);

        const dy = canvas.height - newHeight;
        await ctx.drawImage(this.siloLiquidImage, 0, dy, canvas.width, newHeight);

        ctx.globalCompositeOperation = "destination-in";
        await ctx.drawImage(this.emptySiloWithoutShadeImage, 0, 0, canvas.width, canvas.height);

        ctx.globalCompositeOperation = "multiply";
        await ctx.drawImage(this.emptySiloWithShadeImage, 0, 0, canvas.width, canvas.height);
      }
    },

    loadEmptySiloWithShadeImage() {
      const img = new Image();
      img.src = emptySiloWithShadeImageSrc;
      img.onload = () => (this.emptySiloWithShadeImage = img);
    },

    loadEmptySiloWithoutShadeImage() {
      const img = new Image();
      img.src = emptySiloWithoutShadeImageSrc;
      img.onload = () => (this.emptySiloWithoutShadeImage = img);
    },

    loadSiloLiquidImage() {
      const img = new Image();
      img.src = siloLiquidImageSrc;
      img.onload = () => (this.siloLiquidImage = img);
    },
  },

  mounted() {
    this.loadEmptySiloWithShadeImage();
    this.loadEmptySiloWithoutShadeImage();
    this.loadSiloLiquidImage();
  },

  watch: {
    value() {
      this.applyMask();
    },

    allImagesLoaded(value) {
      if (value) this.applyMask();
    },

    input: {
      handler() {
        this.applyMask();
      },
      deep: true,
    },
  },
};
</script>
